import { DeleteSweepRounded } from '@mui/icons-material';
import { Grid, IconButton } from '@mui/material';
import React from 'react';
import ExternalScreen from '../../components/fragments/ExternalScreen';
import ListEmpty from '../../components/fragments/ListEmpty';

export default function GuestNotificationsScreen() {
    return (
        <ExternalScreen
            title="Notifications"
            controls={
                <IconButton
                    color="primary"
                    // sx={{ color: 'secondary.main', mr: 1 }}
                >
                    <DeleteSweepRounded />
                </IconButton>
            }
        >
            <Grid item xs={12}>
                {/* <List>
                    <ListSubheader>Today</ListSubheader>
                    {pastors.map(({ id, name }) => (
                        <ListItem sx={{ px: 0 }} key={id}>
                            <ListItemAvatar>
                                <Avatar>{name?.slice(0, 1)}</Avatar>
                            </ListItemAvatar>
                            <ListItemText
                                secondary={name?.slice(0, 70) + '...'}
                            />
                        </ListItem>
                    ))}
                </List> */}
                <ListEmpty />
            </Grid>
        </ExternalScreen>
    );
}
